
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Vue } from "vue-class-component";
import generateManifest from "./manifest-pdf";

class Print extends Vue {
  // get profile account
  get dataProfile() {
    return AccountController.accountData;
  }

  capitalize(word: string) {
    if (!word) return "";
    return word
      .toLowerCase()
      .split(" ")
      .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
      .join(" ");
  }

  printManifest(dataDetail: any) {
    // logo
    const element: any = document;
    const logo = element.getElementById("logo").src;

    // handle data
    const data: any = [];

    dataDetail.sttList.forEach((item: any, index: number) => {
      data.push({
        no: index + 1,
        sttNo: "",
        noRef: "",
        product: "",
        lastStatus: "",
        hanging: "",
        hangingType: "",
        originCity: "",
        destCity: ""
      });
      const sttNo = data[index].sttNo ? "\n\n" : "";
      const noRef = data[index].noRef ? "\n\n" : "";
      const product = data[index].product ? "\n\n" : "";
      const lastStatus = data[index].lastStatus ? "\n\n" : "";
      const hanging = data[index].hanging ? "\n\n" : "";
      const hangingType = data[index].hangingType ? "\n\n" : "";
      const originCity = data[index].originCity ? "\n\n" : "";
      const destinationCity = data[index].destCity ? "\n\n" : "";

      data[index] = {
        ...data[index],
        sttNo: `${data[index].sttNo}${sttNo}${item.sttNo}`,
        noRef: `${data[index].noRef}${noRef}${item.referenceNo}`,
        product: `${data[index].product}${product}${item.shipmentType}`,
        lastStatus: `${data[index].lastStatus}${lastStatus}${item.lastStatus}`,
        hanging: `${data[index].hanging}${hanging}${item.hangingDays} ${this.$t(
          "cariStt.pdf.days"
        )}`,
        hangingType: `${
          data[index].hangingType
        }${hangingType}${item.hangingType.replace("_", " ")}`,
        originCity: `${data[index].originCity}${originCity}${item.originCity3lc}`,
        destCity: `${data[index].destCity}${destinationCity}${item.destinationCity3lc}`
      };
    });
    generateManifest(dataDetail, data, logo);
  }

  // role account user
  get roleAccount() {
    return (
      (this.dataProfile.account_type === "partner"
        ? this.dataProfile.account_type_detail.type
        : this.dataProfile.account_type) || "internal"
    );
  }
}
export default Print;
